import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import axios from "axios";
import { toast } from "react-toastify";
import Select from "react-select";
import { Watch } from "react-loader-spinner"; 

const AddSize = () => {
  let { id } = useParams();
  const navigate = useNavigate();
  const [isError, setError] = useState(false);
  const [userDrp, setUserDrpData] = useState([]);
  const [loading, setLoading] = useState(false); 
  const [formValue, setFormValue] = useState({
    id: null,
    name: "",
    user_id: "",
    unit: "",
    thickness_unit: "",
    thickness: "",
  });

  const saveSize = () => {
    if (!formValue.name) {
      toast.error("Please Fill Out This Field", {
        autoClose: 3000,
        position: "top-center",
      });
      setError(true);
      return false;
    }
    {
      setLoading(true);
      setError(false);
      const pUrl = id ? API_URL.SIZE_UPDATE : API_URL.SIZE_SAVE;
      axios.post(pUrl, formValue).then((res) => {
        if (res.data.status === 1) {
          if (id) {
            toast.success("Updated", {
              autoClose: 3000,
              position: "top-center",
            });
            setTimeout(() => {
              navigate("/admin/size", { replace: true });
            }, 100);
          } else {
            setTimeout(() => {
              navigate("/admin/size", { replace: true });
            }, 100);
            toast.success("Saved", { autoClose: 3000, position: "top-center" });
          }
        }
        setLoading(false);
      });
    }
  };

  const isShowError = (value) => {
    if (
      isError &&
      (!value || value == "" || value == null || value == undefined)
    ) {
      return true;
    }
    return false;
  };

  const resetForm = () => {
    setFormValue({
      id: null,
      name: "",
      user: "",
      unit: "",
      thickness_unit: "",
      thickness: "",
    });
  };

  const onEdit = () => {
    axios.post(API_URL.SIZE_GET, { id: id }).then((res) => {
      if (res.data.status === 1) {
        setFormValue({
          id: res.data.data.id,
          name: res.data.data.name ? res.data.data.name : "",
          user_id: res.data.data.user_id ? res.data.data.user_id : "",
          thickness_unit: res.data.data.thickness_unit
            ? res.data.data.thickness_unit
            : "",
          unit: res.data.data.unit ? res.data.data.unit : "",
          thickness: res.data.data.thickness ? res.data.data.thickness : "",
        });
      }
    });
  };

  const getUser = () => {
    axios.post(API_URL.USER_LIST, { id: id }).then((res) => {
      setUserDrpData(res.data.data.data);
      let cd = res.data.data.data.map((caw) => {
        return {
          label: caw.name,
          value: caw.id,
        };
      });
      setUserDrpData(cd);
    });
  };

  const styles = {
    menu: (baseStyles, state) => ({
      ...baseStyles,
      marginTop: 2,
      zIndex: 999,
    }),
  };
  const getInputStyles = (isError) => ({
    borderColor: isError ? "red" : undefined,
  });

  useEffect(() => {
    getUser();
  }, []);

  useEffect(() => {
    id && onEdit();
  }, [id]);

  return (
    <>
      <div className="page-header">
        <div className="content-page-header">
          <h5>{id ? "Edit" : "Add"} Size</h5>
          <div className="list-btn">
            <ul className="filter-list">
              <li>
                <Link to={"/admin/size"} className="btn btn-sm btn-secondary">
                  <i className="fa fa-backward me-2" aria-hidden="true"></i>Back
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <form onSubmit={(event) => event.preventDefault()}>
            <div className="row">
              <div className="col-md-4">
                <div className="form-group">
                  <label
                    className={`form-label ${
                      isShowError(formValue.user_id) && "required-field"
                    }`}
                  >
                    Client<span className="required-star">*</span>
                  </label>
                  <Select
                    options={userDrp}
                    value={userDrp.find((r) => r.value === formValue.user_id)}
                    styles={{
                      ...styles,
                      control: (base) => ({
                        ...base,
                        borderColor: isShowError(formValue.user_id)
                          ? "red"
                          : base.borderColor,
                      }),
                    }}
                    onChange={(e) => {
                      setFormValue({ ...formValue, user_id: e.value });
                    }}
                  />
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label
                    className={`form-label ${
                      isShowError(formValue.name) && "required-field"
                    }`}
                  >
                    Tiles Size Name<span className="required-star">*</span>
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formValue.name}
                    className="form-control"
                    placeholder="Ex. 600x1200"
                    id="name"
                    style={getInputStyles(isShowError(formValue.name))}
                    onChange={(event) => {
                      setFormValue({ ...formValue, name: event.target.value });
                    }}
                  />
                </div>
              </div>

              <div className="col-lg-4 col-md-6 col-sm-12">
                <div className="form-group">
                  <label
                    className={`form-label ${
                      isShowError(formValue.unit) && "required-field"
                    }`}
                  >
                    {" "}
                    Tiles Size Unit<span className="required-star">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Ex. MM"
                    value={formValue.unit}
                    style={getInputStyles(isShowError(formValue.unit))}
                    onChange={(event) => {
                      setFormValue({ ...formValue, unit: event.target.value });
                    }}
                    className="form-control"
                  />
                </div>
              </div>

              <div className="col-md-4">
                <div className="form-group">
                  <label
                    className={`form-label ${
                      isShowError(formValue.thickness) && "required-field"
                    }`}
                  >
                    Tiles Size Thickness<span className="required-star">*</span>
                  </label>
                  <input
                    type="text"
                    name="thickness"
                    placeholder="Ex. 9"
                    value={formValue.thickness}
                    className="form-control"
                    style={getInputStyles(isShowError(formValue.thickness))}
                    id="thickness"
                    onChange={(event) => {
                      setFormValue({
                        ...formValue,
                        thickness: event.target.value,
                      });
                    }}
                  />
                </div>
              </div>

              <div className="col-lg-4 col-md-6 col-sm-12">
                <div className="form-group">
                  <label
                    className={`form-label ${
                      isShowError(formValue.thickness_unit) && "required-field"
                    }`}
                  >
                    Tiles Thickness Unit<span className="required-star">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Ex. MM"
                    value={formValue.thickness_unit}
                    style={getInputStyles(
                      isShowError(formValue.thickness_unit)
                    )}
                    onChange={(event) => {
                      setFormValue({
                        ...formValue,
                        thickness_unit: event.target.value,
                      });
                    }}
                    className="form-control"
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="form-group text-end">
                <button
                  type="submit"
                  onClick={saveSize}
                  disabled={loading}
                  className="btn btn-sm btn-primary"
                >
                  {loading ? (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Watch color={"white"} height={20} width={20} />
                    </div>
                  ) : (
                    "Save"
                  )}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AddSize;
